import React from "react";
import {
  FadeLeft,
  FadeRight,
  TabButton,
  TabListRoot,
  TabScroller,
} from "./KgNodePanelTabs.styles";
import type { KgNodePanelTabsProps } from "./KgNodePanelTabs.types";

export const KgNodePanelTabs: React.FC<KgNodePanelTabsProps> = ({
  tabs,
  activeTab,
  onChange,
  scrollRef,
  setTabRef,
  onScroll,
  canScrollLeft = false,
  canScrollRight = false,
  fitContent = false,
  density = "default",
}) => (
  <TabListRoot $fitContent={fitContent} role="tablist">
    <FadeLeft $visible={canScrollLeft} aria-hidden />
    <FadeRight $visible={canScrollRight} aria-hidden />
    <TabScroller ref={scrollRef} onScroll={onScroll} $density={density}>
      {tabs.map(({ id, label, count }) => {
        const isActive = id === activeTab;
        const displayLabel =
          count != null ? `${label} (${count})` : label;
        return (
          <TabButton
            key={id}
            ref={setTabRef?.(id)}
            type="button"
            role="tab"
            aria-selected={isActive}
            $isActive={isActive}
            $density={density}
            onClick={() => onChange(id)}
          >
            {displayLabel}
          </TabButton>
        );
      })}
    </TabScroller>
  </TabListRoot>
);

export default KgNodePanelTabs;
